import { Component, OnInit } from '@angular/core'
import { MaterialService } from './material.service'
import { MaterialModel } from './material.model'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-material.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './material.master.component.html',
  styleUrl: './material.master.component.css',
})
export class MaterialMasterComponent {
  materialColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'materialName',
      displayName: 'Material Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private materialService: MaterialService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  openAddUpdateMaterialDialog(mode: string, material?: MaterialModel): void {
    const fields = this.materialColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: material || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateMaterial(result)
        } else {
          this.addMaterial(result)
        }
      }
    })
  }

  addMaterial(material: any): void {
    this.materialService.addMaterial(material).subscribe({
      next: () => {
        this.toastr.success('Material Added Successfully!', 'Success')
        this.masterCommonService.getAllMaterials()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateMaterial(material: any): void {
    this.materialService.updateMaterial(material).subscribe({
      next: () => {
        this.toastr.success('Material Updated Successfully!', 'Success')
        this.masterCommonService.getAllMaterials()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteMaterial(material: MaterialModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this material?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        material.isDeleted = true
        this.materialService.deleteMaterial(material).subscribe({
          next: () => {
            this.masterCommonService.materialsList = this.masterCommonService.materialsList.filter(
              (p) => p.id !== material.id,
            )
            this.toastr.success('Material Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
